import {isNil, isNotNil} from 'ramda';
import {isNilOrEmpty, isNotNilOrEmpty} from 'ramda-adjunct';

import {Nullish} from 'shared/web';

interface PaymentCardPrefillInput {
  invoiceTemplateId: string | Nullish;
  invoiceDocSeriesId: string | Nullish;
  dependentDocSeriesIds: Record<string, string | Nullish>;
  primaryTemplateId: string | Nullish;
  soleDocSeriesId: string | Nullish;
}

const INVOICE_TEMPLATE_PATH = 'invoice.templateId';
const INVOICE_DOC_SERIES_PATH = 'invoice.docSeriesId';

// Each field is filled on its own, so a card with an invoice series but an empty corrective one is
// still repaired.
export function getPaymentCardPrefill(
  input: PaymentCardPrefillInput
): Partial<Record<string, string>> {
  const prefill: Partial<Record<string, string>> = {};

  if (isNilOrEmpty(input.invoiceTemplateId) && isNotNil(input.primaryTemplateId)) {
    prefill[INVOICE_TEMPLATE_PATH] = input.primaryTemplateId;
  }

  const docSeriesId = isNotNilOrEmpty(input.invoiceDocSeriesId)
    ? input.invoiceDocSeriesId
    : input.soleDocSeriesId;

  // Written out rather than `isNilOrEmpty`, which does not narrow away null here.
  if (isNil(docSeriesId) || docSeriesId === '') {
    return prefill;
  }

  if (isNilOrEmpty(input.invoiceDocSeriesId)) {
    prefill[INVOICE_DOC_SERIES_PATH] = docSeriesId;
  }

  Object.entries(input.dependentDocSeriesIds).forEach(([section, currentDocSeriesId]) => {
    if (isNilOrEmpty(currentDocSeriesId)) {
      prefill[`${section}.docSeriesId`] = docSeriesId;
    }
  });

  return prefill;
}
